const state = {
  deleteReferenceConfirmDialog: {
    message: "Are you sure you want to delete this reference?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteExperienceConfirmDialog: {
    message: "Are you sure you want to delete this experience?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteContactConfirmDialog: {
    message: "Are you sure you want to delete this contact?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteEducationConfirmDialog: {
    message: "Are you sure you want to delete this education?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteChildrenConfirmDialog: {
    message: "Are you sure you want to delete this child?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deletePetConfirmDialog: {
    message: "Are you sure you want to delete this pet?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteBookingConfirmDialog: {
    message: "Are you sure you want to delete this booking?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteProfileBuilderConfirmDialog: {
    message: "Are you sure you want to delete the profile builder {0}?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteRequestConfirmDialog: {
    message: "Are you sure you want to delete this request?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteJobConfirmDialog: {
    message: "Are you sure you want to delete this job?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteApplicationConfirmDialog: {
    message: "Are you sure you want to delete this application?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteDocumentConfirmDialog: {
    message: "Are you sure you want to delete the document {0}?",
    acceptLabel: "Delete Document",
    rejectLabel: "Close"
  },
  deleteFileConfirmDialog: {
    message: "Are you sure you want to delete the file?",
    acceptLabel: "Delete",
    rejectLabel: "Close"
  },
  deleteTemplateConfirmDialog: {
    message: "Are you sure you want to delete the {0} template {1}?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deletePriceConfirmDialog: {
    message: "Are you sure you want to delete the {0} {1}?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteUserConfirmDialog: {
    innerHtml: `<h3>Are you sure you want to delete this user?</h3>
    <h4>It may be better to set their status to Rejected or Inactive so you retain the information.</h4>
    <p>{0} {1}</p>
    <p>{2}</p>`,
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteAdminConfirmDialog: {
    innerHtml: `<h3>Are you sure you want to delete this user?</h3>
    <p>{0}</p>`,
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteResourceConfirmDialog: {
    message: "Are you sure you want to remove {0}?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  cancelBookingConfirmDialog: {
    message: "Are you sure you want to cancel this booking? {0}",
    showReasonInput: true,
    reasonOnConfirmLabel: "Please explain why you are canceling this booking?",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  cancelConfirmDialog: {
    message: "Are you sure you want to close? Any changes will be lost.",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  editConfirmDialog: {
    message: "Are you sure of your changes?",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  bulkStatusChangeConfirmDialog: {
    message: "Are you sure you want to change the status of the {0} selected users? Their status will be changed to {1}.",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  overwriteVideoConfirmDialog: {
    message: "There is a recorded video. If you record new video, the existed video will be overwritten. Are you sure to continue?",
    acceptLabel: "Continue",
    rejectLabel: "Cancel"
  },
  deleteProfilePictureConfirmDialog: {
    message: "Are you sure you want to delete the profile picture?",
    acceptLabel: "Delete Picture",
    rejectLabel: "Close"
  },
  deleteRelationshipConfirmDialog: {
    message: "Are you sure you want to remove the link between {0} and this client?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  candidateAcceptJobConfirmDialog: {
    message: "You are committing to filling this job, are you sure?",
    acceptLabel: "Accept Job",
    rejectLabel: "Close"
  },
  markAsFavoriteConfirmDialog: {
    message: "Are you sure you want to mark {0} as favorite?",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  markAsDoNotWantConfirmDialog: {
    message: "Are you sure you do not want {0} again?",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  deleteNoteConfirmDialog: {
    innerHtml: `<h3>Are you sure you want to delete the note?</h3>
    <p style="white-space: pre-wrap;">{0}</p>`,
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteCreditConfirmDialog: {
    message: "Are you sure you want to delete this credit?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
};

const mutations = {};

const actions = {};

const getters = {
  deleteReferenceConfirmDialog(state) {
    return state.deleteReferenceConfirmDialog;
  },
  deleteExperienceConfirmDialog(state) {
    return state.deleteExperienceConfirmDialog;
  },
  deleteContactConfirmDialog(state) {
    return state.deleteContactConfirmDialog;
  },
  deleteEducationConfirmDialog(state) {
    return state.deleteEducationConfirmDialog;
  },
  deleteChildrenConfirmDialog(state) {
    return state.deleteChildrenConfirmDialog;
  },
  deleteBookingConfirmDialog(state) {
    return state.deleteBookingConfirmDialog;
  },
  deletePetConfirmDialog(state) {
    return state.deletePetConfirmDialog;
  },
  deleteProfileBuilderConfirmDialog(state) {
    return state.deleteProfileBuilderConfirmDialog;
  },
  deleteRequestConfirmDialog(state) {
    return state.deleteRequestConfirmDialog;
  },
  deleteJobConfirmDialog(state) {
    return state.deleteJobConfirmDialog;
  },
  deleteApplicationConfirmDialog(state) {
    return state.deleteApplicationConfirmDialog;
  },
  deleteDocumentConfirmDialog(state) {
    return state.deleteDocumentConfirmDialog;
  },
  deleteFileConfirmDialog(state) {
    return state.deleteFileConfirmDialog;
  },
  deleteTemplateConfirmDialog(state) {
    return state.deleteTemplateConfirmDialog;
  },
  deletePriceConfirmDialog(state) {
    return state.deletePriceConfirmDialog;
  },
  deleteUserConfirmDialog(state) {
    return state.deleteUserConfirmDialog;
  },
  deleteAdminConfirmDialog(state) {
    return state.deleteAdminConfirmDialog;
  },
  deleteResourceConfirmDialog(state) {
    return state.deleteResourceConfirmDialog;
  },
  cancelBookingConfirmDialog(state) {
    return state.cancelBookingConfirmDialog;
  },
  cancelConfirmDialog(state) {
    return state.cancelConfirmDialog;
  },
  editConfirmDialog(state) {
    return state.editConfirmDialog;
  },
  bulkStatusChangeConfirmDialog(state) {
    return state.bulkStatusChangeConfirmDialog;
  },
  overwriteVideoConfirmDialog(state) {
    return state.overwriteVideoConfirmDialog;
  },
  deleteProfilePictureConfirmDialog(state) {
    return state.deleteProfilePictureConfirmDialog;
  },
  deleteRelationshipConfirmDialog(state) {
    return state.deleteRelationshipConfirmDialog;
  },
  candidateAcceptJobConfirmDialog(state) {
    return state.candidateAcceptJobConfirmDialog;
  },
  markAsFavoriteConfirmDialog(state) {
    return state.markAsFavoriteConfirmDialog;
  },
  markAsDoNotWantConfirmDialog(state) {
    return state.markAsDoNotWantConfirmDialog;
  },
  deleteNoteConfirmDialog(state) {
    return state.deleteNoteConfirmDialog;
  },
  deleteCreditConfirmDialog(state) {
    return state.deleteCreditConfirmDialog;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/confirm-dialog-content.js